"use client";

import Image from "next/image";

interface BenefitCard {
    title: string;
    bulletPoints: {
        icon: string;
        text: string;
    }[];
    image: string;
    imageAlt: string;
    bgColor: string;
}

interface BenefitsRowProps {
    heading: string;
    description: string;
    cards: BenefitCard[];
}

export function BenefitsRow({
    heading,
    description,
    cards
}: BenefitsRowProps) {
    return (
        <div className="my-2 lg:my-8 mb-24 lg:mb-32 xl:mb-40 flex w-full flex-col">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 pb-4">
                <div className="flex flex-col">
                    <div className="flex flex-col justify-start pb-4 text-center leading-[50px] lg:leading-[70px] md:leading-[60px]">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{heading}</h2>
                    </div>
                    <div className="text-center">
                        <p className="text-lg text-gray-600">{description}</p>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <div className="mx-auto max-w-6xl">
                    <div className="flex flex-col lg:flex-row gap-8 lg:gap-x-8 xl:gap-x-12">
                        {cards.map((card, index) => (
                            <div key={index} className={`${card.bgColor} rounded-3xl p-8 shadow-lg h-[500px] relative flex flex-col flex-1`}>
                                {/* Title */}
                                <h3 className="text-2xl font-bold text-white mb-6">{card.title}</h3>
                                
                                {/* Bullet Points */}
                                <div className="space-y-3 mb-2">
                                    {card.bulletPoints.map((point, pointIndex) => (
                                        <div key={pointIndex} className="flex items-center gap-3">
                                            <div className="shrink-0">
                                                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center p-1">
                                                    <Image
                                                        src={point.icon}
                                                        alt=""
                                                        width={24}
                                                        height={24}
                                                        className="w-6 h-6"
                                                    />
                                                </div>
                                            </div>
                                            <span className="text-white font-medium">{point.text}</span>
                                        </div>
                                    ))}
                                </div>
                                
                                {/* Image */}
                                <div className="mt-auto pt-4">
                                    <Image
                                        src={card.image}
                                        alt={card.imageAlt}
                                        width={400}
                                        height={300}
                                        className="w-full h-48 object-cover rounded-xl"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
